import React from "react";

export default function Filter({ records, downloadStandingPDF, downloadExcel }) {
  return (
    <div className="filter px-4">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {records}
        </button>
      </div>
      <div className="filterright">
        <button onClick={downloadExcel} className={"NavLinkBtn hover marginright unselectlink"}>
          EXCEL
        </button>
        {/* <button className={"NavLinkBtn hover marginright unselectlink"}>
          HTML
        </button> */}
        <button
          onClick={downloadStandingPDF}
          className={"NavLinkBtn hover marginright unselectlink"}
        >
          PDF
        </button>
      </div>
    </div>
  );
}
